// Imports
import axios from "axios";
import { createRealmApp } from "./RealmApp";
import { applyPromotions, getPromotionMessage, resolvePrices, buildPromotions, PRICE_CONSTANTS, AGE_CONSTANTS } from "./promotions";
require("./interceptor");
const dataSource = process.env.REACT_APP_MONGO_DATASOURCE;
const database = process.env.REACT_APP_MONGO_DATABASE;

let today = new Date();
export const specialPricing2025 = today <= new Date('2026-01-07');

/**
 * Compute the foal enrollment price.
 *
 * @param foal birth year of the foal
 * @param sire enrolled year of the sire
 * @param config optional settings ({ foalPricing, promotions }) from the
 *   management settings API. When omitted (or partial), the built-in
 *   PRICE_CONSTANTS and hardcoded promotion schedule are used as a fallback.
 */
export function pricingRulesEngine(foal, sire, config = null) {
  let price = 0;
  let year = today.getFullYear();
  let sireAge = year - Number(sire);
  let foalAge = year - Number(foal);

  // Resolve tier prices from config, falling back to PRICE_CONSTANTS.
  const P = resolvePrices(config && config.foalPricing);
  // Build the promo list from config; null => use built-in schedule.
  const promoList = config && config.promotions
    ? buildPromotions(config.promotions, year)
    : null;

  if (
    today >= new Date("December 31, " + (year - 1).toString() + " 11:59:59") &&
    today <= new Date("March 17, " + year.toString() + " 11:59:59")
  ) {
    if (sireAge > AGE_CONSTANTS.SIRE_ENROLLED) {
      if (foalAge > AGE_CONSTANTS.FOAL_AGE_3_PLUS) price = P.PREMIUM_3_PLUS;
      else if (foalAge == AGE_CONSTANTS.FOAL_AGE_3) price = P.STANDARD_3;
      else if (foalAge == AGE_CONSTANTS.FOAL_AGE_2) price = P.STANDARD_2;
      else if (foalAge == AGE_CONSTANTS.FOAL_AGE_1) price = P.BASE_FEE;
      else if (foalAge >= AGE_CONSTANTS.FOAL_AGE_0) price = P.BASE_FEE;
      else price = P.BASE_FEE;
    }
    if (sireAge <= AGE_CONSTANTS.SIRE_ENROLLED) {
      price = P.BASE_FEE;
    }
  }

  /*
    After March 15th
  */
  if (today >= new Date("March 17, " + year.toString() + " 11:59:59")) {
    //2021 or 2022
    if (sireAge > AGE_CONSTANTS.SIRE_ENROLLED) {
      if (foalAge > AGE_CONSTANTS.FOAL_AGE_3_PLUS) {
        price = P.PREMIUM_3_PLUS;
      } else if (foalAge == AGE_CONSTANTS.FOAL_AGE_3) {
        price = P.STANDARD_3;
      } else if (foalAge == AGE_CONSTANTS.FOAL_AGE_2) {
        price = P.STANDARD_2;
      } else if (foalAge == AGE_CONSTANTS.FOAL_AGE_1) {
        price = P.STANDARD_1;
      } else if (foalAge >= AGE_CONSTANTS.FOAL_AGE_0) {
        price = P.BASE_FEE;
      } else {
        price = P.BASE_FEE;
      }
    }

    if (sireAge <= AGE_CONSTANTS.SIRE_ENROLLED) {
      if (foalAge > AGE_CONSTANTS.FOAL_AGE_0) price = P.STANDARD_1;
      else price = P.BASE_FEE;
    }
  }

  if (specialPricing2025 && (price === P.STANDARD_3 || price === P.PREMIUM_3_PLUS)) {
    price = P.PROMO_CAP;
  }
  //over ride to base fee if engine fails

  if (price == 0) price = P.BASE_FEE;

  if (
    today >= new Date("June 1, " + year.toString() + " 00:00:01") &&
    today <= new Date("June 4, " + year.toString() + " 11:59:59") &&
    (price == P.STANDARD_3 || price == P.PREMIUM_3_PLUS)
  ) {
    price = P.PROMO_CAP;
  }

  //override for upcoming year stallions after October 1st - always charge $250
  if(today >= new Date("October 1, " + year.toString() + " 00:00:01") && sire == (year + 1)) {
    price = P.BASE_FEE;
  }

  price = applyPromotions(price, foalAge, today, promoList);
  return price;
}
const insert = (collection, data) => {
  return axios
    .post(`/action/insertOne`, {
      dataSource,
      database,
      collection: collection,
      document: data,
    })
    .then((response) => {
      return response.data.documents;
    })
    .catch((error) => {
      throw error;
    });
};

const get = (collection, query) => {
  return axios
    .post(`/action/find`, {
      dataSource,
      database,
      collection: collection,
      filter: query,
    })
    .then((response) => {
      return response.data.documents;
    })
    .catch((error) => {
      throw error;
    });
};

export async function generateId() {
  const app = createRealmApp();
  const mongo = app.mongoClient("mongodb-atlas");
  const db = mongo.db("legends");
  const last = await db
    .collection("nominators")
    .aggregate([
    {
      $project: {
        membershipId: 1,
        numericId: {
          $toInt: {
            $arrayElemAt: [
              {
                $split: ["$membershipId", "TL-"]
              },
              1
            ]
          }
        }
      }
    },
    {
      $sort: {
        numericId: -1
      }
    },
    {
      $limit: 1
    }
  ]);
  const num = Number(last[0].membershipId.split("TL-")[1]);
  return `TL-${num + 1}`;
}

export const formatMoney = (amount) => {
  if (!amount) return "";
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

export const formatDate = (dateString) => {
  let date = dateString
  if (!dateString) return "";
  if (typeof date == 'string') date = new Date(dateString);

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC'
  }).format(date);
};

export { getPromotionMessage };